export default "__VITE_ASSET__67befa56__"